import { Button } from '@/components/ui/button'

const Footer = ({ selectionCount, onAttachSelected, onCancel, hasExcludedAudiences = false }) => {
    const isDisabled = selectionCount === 0 || hasExcludedAudiences
    
    return (
        <div className="tw:w-full">
            <div className="tw:flex tw:justify-end tw:gap-4 tw:w-full">
                <Button variant="secondary" className="tw:w-[156px] tw:!text-sm" onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    variant="default"
                    className={`tw:w-[156px] tw:!text-sm ${hasExcludedAudiences ? 'tw:bg-gray-200 tw:text-gray-500 tw:cursor-not-allowed' : ''}`}
                    onClick={onAttachSelected}
                    disabled={isDisabled}
                >
                    Attach Selected{selectionCount > 0 ? ` (${selectionCount})` : ''}
                </Button>
            </div>
        </div>
    )
}

Footer.displayName = 'Footer'

export { Footer }
